import React from 'react';
import NavScreen from '../../Screens/Navbar/Navbar';

const FeedbackScreen = () => {
  return (
    <div style={{ paddingTop: '60px', paddingBottom: '60px' }}>
      <h2 style={{ textAlign: 'center' }}>Feedback Screen</h2>
      <NavScreen />
    </div>
  );
};

export default FeedbackScreen;
